<div class="md:flex md:items-center">
    <div class="relative overflow-hidden md:shrink-0 md:rounded-md rounded-t-md shadow dark:shadow-gray-700 md:m-3 mx-3 mt-3">
        <img [src]="packageData.image" class="h-full w-full object-cover md:w-48 md:h-56 scale-125 group-hover:scale-100 duration-500" alt="">
        <div *ngIf="packageData.tag" class="absolute top-0 start-0 p-4">
            <span class="bg-red-500 text-white text-[12px] px-2.5 py-1 font-medium rounded-md h-5">{{packageData.tag}}</span>
        </div>

        <div class="absolute top-0 end-0 p-4">
            <a [routerLink]="[]" class="size-8 inline-flex justify-center items-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full text-slate-100 dark:text-slate-700 focus:text-red-500 dark:focus:text-red-500 hover:text-red-500 dark:hover:text-red-500"><i class="mdi mdi-heart text-[20px] align-middle"></i></a>
        </div>
    </div>

    <div class="p-4 w-full">
        <p class="flex items-center text-slate-400 font-medium mb-2"><i data-feather="map-pin" class="text-red-500 size-4 me-1"></i> {{packageData.place}}</p>
        <a [routerLink]="['/location-detail-one', packageData.id]" class="text-lg font-medium hover:text-red-500 duration-500 ease-in-out">{{packageData.title}}</a>

        <div class="flex items-center mt-2">
            <span class="text-slate-400">Rating:</span>
            <ul class="text-lg font-medium text-amber-400 list-none ms-2">
                <li class="inline"><i class="mdi mdi-star align-middle"></i></li>
                <li class="inline"><i class="mdi mdi-star align-middle"></i></li>
                <li class="inline"><i class="mdi mdi-star align-middle"></i></li>
                <li class="inline"><i class="mdi mdi-star align-middle"></i></li>
                <li class="inline"><i class="mdi mdi-star align-middle"></i></li>
                <li class="inline text-black dark:text-white text-sm">5.0(30)</li>
            </ul>
        </div>

        <div class="mt-4 pt-4 flex justify-between items-center border-t border-slate-100 dark:border-gray-800">
            <h5 class="text-lg font-medium text-red-500">{{packageData.amount}}</h5>

            <a [routerLink]="[]" class="text-slate-400 hover:text-red-500">Explore Now <i class="mdi mdi-arrow-right"></i></a>
        </div>
    </div>
</div>
